import styled from "@emotion/styled";
import { MenuProps } from "antd5";
import { Dropdown } from "antd5/lib";

import Button from "components/ui/button/Button";
import { toast } from "components/ui/toast/Toast";
import { useLeadWorkflow } from "lib/hooks/api/leads/useLeadWorkflow";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { useUpdateLeads } from "../../../lib/hooks/api/leads/useUpdateLeads";
import { pluralise } from "../../../lib/utils";
import { renderStageOption } from "../../shared/stage/stageSelectUtils";
import { processTransitions } from "../../shared/stage/utils";

export function LeadStageBulkUpdateButton({ selectedLeadIds }: { selectedLeadIds: string[] }) {
  const { data } = useLeadWorkflow();
  const transitions = data ? processTransitions(data.transitions) : [];

  const { mutate: updateLeads } = useUpdateLeads({
    onSuccess: (data) => {
      const stageName = data.updateLeads[0]?.stage?.name || "Unknown";
      toast.success(
        `${pluralise(data.updateLeads.length, "lead")} changed to '${stageName}' stage`,
      );
    },
    onError: () => {
      toast.error("Failed to update lead stage");
    },
  });

  const stageMenuItems: MenuProps["items"] = transitions.map((transition) => ({
    key: transition.label,
    type: "group",
    label: transition.label,
    children: transition.options.map((option) => ({
      key: option.value,
      label: renderStageOption(option.label, option.value, transitions),
      onClick: () => {
        if (!option.value) return;
        updateLeads({
          updateLeadsRequest: { ids: selectedLeadIds, updateData: { stageId: option.value } },
        });
      },
    })),
  }));

  return (
    <Dropdown
      menu={{ items: stageMenuItems }}
      trigger={["click"]}
      dropdownRender={(menu) => <DropdownContainer>{menu}</DropdownContainer>}
    >
      <Button icon="alignTop02">
        Stage
        <UIcon icon="chevronDown" size={16} />
      </Button>
    </Dropdown>
  );
}

const DropdownContainer = styled.div({
  maxHeight: 300,
  overflow: "auto",
  borderRadius: 8,
  boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.12)",
});
